import type { TaskTemplate } from "../../domain/entities.ts";

export const noteTemplateLimit = 20_000;
export interface NoteStarter { id: string; name: string; body: string }
export const noteStarters: readonly NoteStarter[] = [
  { id: "meeting", name: "Meeting", body: "# {{title}}\n{{date}}\n\n## Discussion\n\n## Decisions\n\n## Actions\n" },
  { id: "brief", name: "Project brief", body: "# {{title}}\n\n## Goal\n\n## Success criteria\n\n## Scope\n\n## Next steps\n" },
  { id: "decision", name: "Decision", body: "# {{title}}\n{{date}}\n\n## Context\n\n## Options\n\n## Decision\n\n## Follow-up\n" },
  { id: "troubleshooting", name: "Troubleshooting", body: "# {{title}}\n{{date}}\n\n## Problem\n\n## Evidence\n\n## Attempts\n\n## Resolution\n" },
];

/** Literal, single-pass placeholders: no expressions, scripts, or recursive expansion. */
export function expandNoteTemplate(body: string, title: string, date: string): string {
  return body.replace(/\{\{(title|date)\}\}/g, (_match, name: string) => name === "title" ? title : date);
}

export function composeNoteTemplate(body: string, content: string, mode: string, start = body.length, end = start): string {
  if (mode === "replace") return content;
  if (mode === "insert") return body.slice(0, start) + content + body.slice(end);
  return body + (body.trim() ? "\n\n" : "") + content;
}

export function noteTemplateRecord(id: string, rootId: string, name: string, body: string, now: number): TaskTemplate {
  if (!name.trim() || new TextEncoder().encode(name.trim()).length > 120) throw new Error("Use a shorter, non-empty template name");
  if (!body.trim() || new TextEncoder().encode(body).length > noteTemplateLimit) throw new Error("Use non-empty template text under 20 KB");
  return { id, rootId, purpose: "note", name: name.trim(), title: name.trim(), description: body, type: "text", subtasks: [], priority: "none", dueOffsetDays: null, categoryId: null, tags: [], deleted: false, createdAt: now, updatedAt: now };
}
